import styled from 'styled-components';
export { StyledFilter } from './StyledFilter';
export { StyledWrapper } from './StyledWrapper';
export { StyledSelectFilter } from './StyledSelectFilter';

export const reactSelectStyles = {
  container: (base, props = {}) => {
    const { selectProps: { containerWidth = 250 } = {} } = props;
    return {
      ...base,
      width: containerWidth === 'auto' ? 'auto' : `${containerWidth}px`,
      boxShadow: 'none',
    };
  },
  control: (base) => ({
    ...base,
    borderColor: '#9B9B9B',
    borderRadius: '0px',
    minHeight: 32,
    '&:hover': { borderColor: '#9B9B9B' },
    boxShadow: 'none',
  }),
  multiValueLabel: (base) => ({
    ...base,
    fontWeight: 'bolder',
    fontSize: '100%',
    color: '#3b4f63',
  }),
  // MultiValue margin increased slect height on option selected.
  multiValue: (base) => ({
    ...base,
    margin: '1px 2px',
  }),
  // Dropdown & Clear paddings increased select height by 5 px.
  dropdownIndicator: (base) => ({
    ...base,
    paddingTop: 0,
    paddingBottom: 0,
  }),
  clearIndicator: (base) => ({
    ...base,
    paddingTop: 0,
    paddingBottom: 0,
  }),
  // Avoids Stop-stage cells form J cards to overlap the menu.
  menu: (base) => ({
    ...base,
    zIndex: 10,
  }),
  indicatorSeparator: () => {
    /*noop*/
  }, // removes the "stick"
};

export const transitStatusFilterStyles = (Component) => styled(Component)`
  fieldset label {
    border-color: #9b9b9b;
    width: 96px;

    &:first-child {
      border-radius: 0;
    }

    &:last-child {
      border-radius: 0;
    }
  }
`;

export const tasksHandledByFilterStyles = (Component) => styled(Component)`
  margin-right: 0;
  fieldset label {
    border-color: #9b9b9b;
    width: 100%;

    &:first-child {
      border-radius: 0;
      width: 100%;
    }

    &:last-child {
      border-radius: 0;
    }
  }
`;

export const businessFilterStyles = (Component) => styled(Component)`
  fieldset label {
    border-color: #9b9b9b;

    &:first-child {
      border-radius: 0;
    }

    &:last-child {
      border-radius: 0;
    }
  }

  &&.margin-right {
    margin-right: 16px;
`;
